export default function({ precision, sum }) {
    precision = Math.pow(10, precision);
    return Math.round(sum * precision) / precision;
}
